import { useContext, Dispatch } from 'react';
import { LayoutAction, LayoutState } from '../types';
import { LayoutContext } from '../contexts';

export function useLayoutContext(): { state:LayoutState, dispatch: Dispatch<LayoutAction>} {
  const {state, dispatch} = useContext(LayoutContext);
  return {state, dispatch};
}
